import React from 'react';

function ClickWrapper({ children, onClick }) {
  return <>{React.Children.map(children, (child) => React.cloneElement(child, { onClick }))}</>;
}
export default ClickWrapper;
